module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/core-js/modules/_is-object.js
// module id = ../../../../core-js/modules/_is-object.js
// module chunks = 1